import { clearBtnType } from "../types";
import ClearBtnLabel from "./clear-btn-label";

const ClearBtn = ({
  isAddedImage,
  canvasIsChanged,
  helpers,
  isWhite,
  showClearPopup,
  clearAll,
  showPopup,
  sendShowRemovePopup,
  dispatch
}: clearBtnType): JSX.Element => {
  if (!isAddedImage) return <></>;

  return (
    <div className="service__clear">
      <ClearBtnLabel isNeeded={helpers} />
      <button
        className="service__action"
        onClick={() => {
            canvasIsChanged ? showClearPopup(showPopup, sendShowRemovePopup, dispatch) : clearAll(dispatch)
          }
        }
      >
        <i className={`icon__remove ${isWhite ? "icon__remove_white" : ""}`} />
      </button>
    </div>
  );
};

export default ClearBtn;
